import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Heading } from '../../../../ui/components/Heading/Heading';
import styles from './MyClients.module.scss';
import { Button } from '../../../../ui/components/Button/Button';
import { useGQLLazyQuery } from '../../../../ui/utils/graphql';
import { InitialContext } from '../../Layout';
import { Loading } from '../../../../ui/components/Loading/Loading';
import {
  Client,
  GetAllClientsByCompanyDocument,
} from '../../../../gql/graphql';

export const MyClients = () => {
  const { company } = useContext(InitialContext);
  const navigate = useNavigate();
  const {
    data: allClients,
    lazy: lazyAllClients,
    loading,
  } = useGQLLazyQuery<
    Client[],
    {
      companyId: string;
    }
  >(GetAllClientsByCompanyDocument, {
    onCompleted: () => {},
  });

  useEffect(() => {
    if (company) {
      lazyAllClients({
        variables: {
          companyId: company.id,
        },
      });
    }
  }, [company]);

  const renderClients = () => {
    if (allClients?.length === 0) {
      return (
        <div className={styles.empty}>
          No hay clientes en tu nogocio por ahora, crea algunos o espera a que
          se registren en tus servicios.
        </div>
      );
    }

    return allClients?.map((client) => (
      <div key={client.id} className={styles.user}>
        {client.email}
      </div>
    ));
  };

  if (loading) return <Loading />;

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Heading className={styles.heading} headingLevel="h1">
          Mis clientes
        </Heading>
        <Button btnStyle="tertiary" onClick={() => navigate('/clients/create')}>
          Crear nuevo cliente
        </Button>
      </div>
      <p>
        Aquí encontraras a los clientes que se han registrado a través de tus
        aplicaciones y los que hayas registrado
      </p>
      <div className={styles['clients-container']}>{renderClients()}</div>
    </div>
  );
};
